import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import vuetify from './plugins/vuetify'
import GetTextPlugin from 'vue-gettext'
import translations from '../translations.json'

/** @source: https://pinia.vuejs.org/getting-started.html#installation */
import { createPinia, PiniaVuePlugin } from 'pinia'
import ReactiveProvide from 'vue-reactive-provide'
import i18n from './i18n'

Vue.use(GetTextPlugin, {
    availableLanguages: {
        en_GB: 'British English',
        fr_FR: 'Français',
        it_IT: 'Italiano',
    },
    defaultLanguage: 'en_GB',
    languageVmMixin: {
        computed: {
            currentKebabCase: function () {
                return this.current.toLowerCase().replace('_', '-')
            },
        },
    },
    translations: translations,
    silent: true,
})

Vue.config.productionTip = false

Vue.use(PiniaVuePlugin)
const pinia = createPinia()

Vue.use(vuetify, {
    iconfont: 'mdi'
})

Vue.use(ReactiveProvide)

export const eventBus = new Vue()

let vm = new Vue({
    router,
    vuetify,
    render: h => h(App),
    i18n,
    pinia
}).$mount('#app')
